
import { Navigate, useLocation, useNavigate } from "react-router-dom";

import { useEffect, useState } from "react";

// context
import { useAuth } from "./AuthContext";

// idle-timer
import { useIdleTimer } from "react-idle-timer";

// token
import { ensureAuth, clearAccessToken } from "./token";

// mui
import { Box } from "@mui/material";

// project
import RequireContactModal from "components/modal/RequireContactModal";

// Доработка 25. "/medCard" из этого списка вынесен: раздел закрывается не отсутствием
// подтверждённой регистрации, а отсутствием любой доступной медкарты (см. ниже). Остальные
// разделы остались на isVerified - они к карте члена семьи не относятся.
const blockedListUrl = ['/fdoc', '/makeAppointment/direction', '/basket', '/payment'];

export default function RequireVerified({ children }) {
  const {
    isVerified,
    hasMedCard,
    setIsShowWarning,
    setMessageWarning,

    isEmailRequired,
    setIsEmailRequired,
    showModalEmailRequire,
    setShowModalEmailRequire,

    isPhoneRequired,
    setIsPhoneRequired,
    showModalPhoneRequire,
    setShowModalPhoneRequire
  } = useAuth();

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [authState, setAuthState] = useState({
    loading: true,
    success: false
  });

  // проверка на валидность токена
  useEffect(() => {
    let active = true;

    (async () => {
      const result = await ensureAuth();

      if (!active) return;

      setAuthState({
        loading: false,
        success: result.success
      });
    })();

    return () => {
      active = false;
    };
  }, [pathname]);

  useEffect(() => {
    setIsShowWarning(false);
    setMessageWarning({
      title: '',
      description: ''
    });
  }, [pathname]);

  // Функция которая отрабатывает, если пользователь бездействует
  const handleOnIdle = () => {
    clearAccessToken();
    return navigate('/login');
  };

  useIdleTimer({
    timeout: 15 * 60 * 1000,
    onIdle: handleOnIdle,
    debounce: 1000,  // вызываем раз в 1 секунду
    events: ['mousemove', 'keydown', 'wheel', 'touchstart', 'click']
  });

  if (authState.loading) {
    return null;
  }

  if (!authState.success) {
    localStorage.removeItem('isFillProfile');
    localStorage.removeItem('isVerified');

    return <Navigate to='/login' replace/>;
  }

  if (!isVerified) {
    const isBlocked = blockedListUrl.some(
      (path) => pathname === path || pathname.startsWith(path)
    );

    if (isBlocked) {
      return <Navigate to='/main?mode=confirm' replace/>;
    }
  }

  // Доработка 25. Медкарта (и все её подразделы - отсюда startsWith) доступна, пока есть хотя
  // бы одна карта: своя или члена семьи. Если нет ни одной, то нет и своей, то есть
  // пользователь заведомо неподтверждён - поэтому адрес редиректа тот же, что и выше.
  if (!hasMedCard && pathname.startsWith('/medCard')) {
    return <Navigate to='/main?mode=confirm' replace/>;
  }

  return (
    <Box>
      {children}

      {isEmailRequired && showModalEmailRequire && (
        <RequireContactModal
          type="email"
          open={showModalEmailRequire}
          onClose={() => setShowModalEmailRequire(false)}
          onConfirmed={() => {
            setIsEmailRequired(false);
            setShowModalEmailRequire(false);
          }}
        />
      )}

      {isPhoneRequired && showModalPhoneRequire && !showModalEmailRequire && (
        <RequireContactModal
          type="phone"
          open={showModalPhoneRequire}
          onClose={() => setShowModalPhoneRequire(false)}
          onConfirmed={() => {
            setIsPhoneRequired(false);
            setShowModalPhoneRequire(false);
          }}
        />
      )}

    </Box>
  );
}
